<template>
    <div>
        <PageTitle
            title="INSCRIPCIÓN A CANTERA"
            class="strech"
        />       
        
        <PasoUnoComponent 
            v-if="paso1" 
            :esMovil="esMovil" 
            :base="base" 
            :codigo_invitacion="codigo_invitacion" 
            :paso_activo="paso1_activo" 
            @terminado="terminarPasoUno"
            :fields="fields.filter(field => field.pivot.deportista === true)"
        />        
        <PasoDosComponent 
            v-if="paso2" 
            :esMovil="esMovil" 
            :base="base" 
            :paso_activo="paso2_activo" 
            @terminado="terminarPasoDos" 
            @volver="volverPasoUno()"
            :fields="fields.filter(field => field.pivot.representante === true)"
        />        
        <PasoTresComponent v-if="paso3" :esMovil="esMovil" :base="base" :paso_activo="paso3_activo" @terminado="terminarPasoTres()" @volver="volverPasoDos()"/>
        <PasoCuatroComponent v-if="paso4" :esMovil="esMovil" :base="base" :paso_activo="paso4_activo" @terminado="terminarPasoCuatro()" @volver="volverPasoTres()"/>
        <PasoCincoComponent v-if="paso5 && base.categoria_base.tiene_indumentarias" :esMovil="esMovil" :base="base" :paso_activo="paso5_activo" @terminado="terminarPasoCinco" @volver="volverPasoCuatro()"/>
        <PasoSeisComponent v-if="paso6" :esMovil="esMovil" :base="base" :paso_activo="!pago_paycomet" @terminado="procesarCompra" />
        <ProcesarCompraComponent v-if="pago_paycomet" :base="base" />
    </div>
</template>

<script>
    import PageTitle from "@/components/frontend/shared/PageTitle";
    import PasoUnoComponent from "@/components/frontend/bases/PasoUnoComponent";
    import PasoDosComponent from "@/components/frontend/bases/PasoDosComponent";
    import PasoTresComponent from "@/components/frontend/bases/PasoTresComponent";
    import PasoCuatroComponent from "@/components/frontend/bases/PasoCuatroComponent";
    import PasoCincoComponent from "@/components/frontend/bases/PasoCincoComponent";
    import PasoSeisComponent from "@/components/frontend/bases/PasoSeisComponent";
    import ProcesarCompraComponent from "@/components/frontend/bases/ProcesarCompraComponent";

    export default {
        data() {
            return {
                paso1: true,
                paso1_activo: true,
                paso2: false,
                paso2_activo: false,
                paso3: false,
                paso3_activo: false,
                paso4: false,
                paso4_activo: false,
                paso5: false,
                paso5_activo: false,
                paso6: false,
                base: {
                    nacionalidad: "Española",
                    filters: {},
                    fields_deportista: {},
                    fields_responsable_1: {},
                    fields_responsable_2: {}
                },
                pago_paycomet: false,
                codigo_invitacion: null,
                esMovil: false
            };
        },
        head: {
            title: function() {
                return {
                    inner: 'Bases',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }                         
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        created() {
            if(!this.manager.futbol_base || this.manager.activar_compra_por_invitacion_bases && localStorage.getItem('codigo_invitacion') == null) {
                this.$router.push({ name: 'front.home'});
            }
            this.base.filters.tid = this.configuracion.hash_teatro;
            if (this.manager.activar_compra_por_invitacion_bases) {
                this.codigo_invitacion  = localStorage.getItem('codigo_invitacion');
                localStorage.removeItem('codigo_invitacion');
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            fields() {
                return this.lista_abonados.fields_deportistas;
            }
        },
        methods: {
            scrollTo(paso) {
                this.$scrollTo(paso, 100);
            },
            terminarPasoUno(data) {
                this.base = data;
                this.paso2 = true;
                this.paso2_activo = true,
                this.paso1_activo = false,
                this.$nextTick(() => {
                    this.scrollTo('#paso-2');
                });
            },
            volverPasoUno() {
                this.paso2 = false;
                this.paso1_activo = true,
                this.$nextTick(() => {
                    this.scrollTo('#paso-1');
                });
            },
            terminarPasoDos(data) {
                this.base = data;
                this.paso3 = true;
                this.paso2_activo = false,
                this.paso3_activo = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-3');
                });                
            },
            volverPasoDos() {
                this.paso3 = false;
                this.paso2_activo = true,
                this.$nextTick(() => {
                    this.scrollTo('#paso-2');
                });
            },
            terminarPasoTres() {
                this.paso4 = true;
                this.paso3_activo = false,
                this.paso4_activo = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-4');
                });
            },
            volverPasoTres() {
                this.paso4 = false;
                this.paso3_activo = true,
                this.$nextTick(() => {
                    this.scrollTo('#paso-3');
                });
            },
            terminarPasoCuatro() {
                if (this.base.categoria_base.tiene_indumentarias) {
                    this.paso5 = true;
                    this.paso5_activo = true,
                    this.paso4_activo = false,
                    setTimeout(() => {
                        this.$nextTick(() => {
                            this.scrollTo('#paso-5');
                        });
                    }, 1000);
                } else {
                    this.paso6 = true;
                    this.paso4_activo = false;
                    this.$nextTick(() => {
                        this.scrollTo('#paso-6');
                    });
                }
            },
            volverPasoCuatro() {
                this.paso5 = false;
                this.paso4_activo = true,
                this.paso4 = true;
                this.$nextTick(() => {
                    this.scrollTo('#paso-4');
                });
            },
            terminarPasoCinco(indumentariasElegidas) {
                this.base.indumentariasElegidas = indumentariasElegidas;

                this.paso6 = true;
                this.paso5_activo = false,
                this.$nextTick(() => {
                    this.scrollTo('#paso-6');
                });
            },
            procesarCompra() {
                this.pago_paycomet = true;
                this.$nextTick(() => {
                    this.scrollTo('#paycometPaymentForm');
                });
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        components: {
            PageTitle,
            PasoUnoComponent,
            PasoDosComponent,
            PasoTresComponent,
            PasoCuatroComponent,
            PasoCincoComponent,
            PasoSeisComponent,
            ProcesarCompraComponent
        },
    };
</script>